export default "__VITE_ASSET__Dlpis9Fj__"